<template>
  <div class="shopping-cart">
    <h1 style="font-weight: bold">Shopping Cart</h1>
    <div class="emptyCart" v-if="getProductsSize() === 0">
      <p>
        Cart is empty! Go to
        <a href="#">
          <router-link to="/purchase" active-lass="active">
            <a style="font-size: 25px">&nbsp;SHOP&nbsp;</a>
          </router-link>
        </a>
        to continue shopping.
      </p>
    </div>

    <!-- Loop enters -->
    <div class="table-responsive" style="margin: auto">
      <table class="table w-auto" style="width: 100%; color: white">
        <thead>
          <tr>
            <th class="col">
              <h3>Product</h3>
            </th>
            <th class="col"></th>
            <th class="col">
              <h3>Price</h3>
            </th>
            <th class="col">
              <h3>Delivery</h3>
            </th>
            <th class="col">
              <h3>CSC Survey</h3>
            </th>
            <th class="col">
              <h3>Quantity</h3>
            </th>
            <th class="col">
              <h3>Total</h3>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(product, index) in containerList" :key="product.sku">
            <th>
              <img
                style="
                  display: block;
                  margin: auto;
                  width: 80%;
                  max-width: 300px;
                  border-radius: 10px;
                "
                class="image"
                :src="product.image"
                alt
              />
            </th>

            <th>
              <div class="description">
                <h2 style="font-weight: bold">{{ product.title }}</h2>
                <h2 style="font-weight: bold">{{ product.condition }}</h2>
              </div>
              <!-- EDIT BUTTON -->
              <v-btn @click="updateAttributes(product)" class="btns"
                >Edit</v-btn
              >
              <!-- DELETE BUTTON -->
              <v-btn
                class="btns"
                min-width="80px"
                color="red"
                style="color: #ffffff"
                @click.stop="removecontainer(index)"
                >Remove</v-btn
              >
              <!--END OF DELETE BUTTON -->
            </th>

            <td>
              <br />
              <h3
                v-if="totalQuantity >= 1"
                class="unit-price"
                v-bind:class="{
                  'unit-price-linethrough': totalQuantity >= 2,
                }"
              >
                ${{ format(product.price * product.quantity) }}
              </h3>
              <h3 class="unit-price-discount" v-if="totalQuantity >= 2">
                ${{ format(product.price * product.quantity * 0.95) }}
              </h3>
              <p style="font-size: 11px" v-if="totalQuantity >= 2">
                (5% volume discount applied)
              </p>
            </td>

            <td>
              <br />
              <h3 v-if="product.customAttributes.Delivery === 'DELIVERY'">
                ${{ format(product.haulingPrice * product.quantity) }}
                <span
                  href="#"
                  class="pa3 btn"
                  style="color: #00587d; padding: 0"
                  @click.stop="$set(showDeliveryPopup, index, true)"
                >
                  <v-icon style="color: white">info</v-icon>
                </span>
                <br />
                <v-btn
                  @click="updateItemsDelivery('PICK-UP')"
                  style="margin-top: 5px"
                >
                  <span style="font-size: 10px">
                    CHANGE TO
                    <br />PICK-UP
                  </span>
                </v-btn>

                <v-dialog v-model="showDeliveryPopup[index]" max-width="500px">
                  <div class="dialog">
                    <v-icon
                      @click="$set(showDeliveryPopup, index, false)"
                      style="border-radius: 0.8em; background: #6dbe45"
                      >close</v-icon
                    >
                    <h5>{{ deliveryInfoText }}</h5>
                  </div>
                </v-dialog>
              </h3>
              <h3 v-else>
                $0
                <span
                  href="#"
                  class="pa3 btn"
                  style="color: #00587d; padding: 0"
                  @click.stop="$set(showPickupPopup, index, true)"
                >
                  <v-icon style="color: white">info</v-icon>
                </span>
                <br />
                <v-btn
                  @click="updateItemsDelivery('DELIVERY')"
                  style="margin-top: 5px"
                >
                  <span style="font-size: 10px">
                    CHANGE TO
                    <br />DELIVERY
                  </span>
                </v-btn>

                <v-dialog v-model="showPickupPopup[index]" max-width="500px">
                  <div class="dialog">
                    <v-icon
                      @click="$set(showPickupPopup, index, false)"
                      style="border-radius: 0.8em; background: #6dbe45"
                      >close</v-icon
                    >
                    <h5>No additional cost for pick-up.</h5>
                  </div>
                </v-dialog>
              </h3>
            </td>

            <td>
              <br />
              <v-dialog v-model="showCSCPopup[index]" max-width="500px">
                <div class="dialog">
                  <v-icon
                    @click="$set(showCSCPopup, index, false)"
                    style="border-radius: 0.8em; background: #6dbe45"
                    >close</v-icon
                  >
                  <h5>{{ CSCInfoText }}</h5>
                </div>
              </v-dialog>
              <h3 v-if="product.CSCSurvey">
                ${{ product.CSCSurvey.price * product.quantity }}
                <span
                  href="#"
                  class="pa3 btn"
                  style="color: #00587d; padding: 0"
                  @click.stop="$set(showCSCPopup, index, true)"
                >
                  <v-icon style="color: white">info</v-icon>
                </span>
              </h3>
              <h3 v-else>
                -
                <span
                  href="#"
                  class="pa3 btn"
                  style="color: #00587d; padding: 0"
                  @click.stop="$set(showCSCPopup, index, true)"
                >
                  <v-icon style="color: white">info</v-icon>
                </span>
              </h3>
            </td>

            <td>
              <br />
              <number-input
                :value="product.quantity"
                :min="1"
                :max="100"
                @change="setQuantity(product.quantity, $event, index)"
                size="small"
                inline
                center
                controls
                style="max-width: 110px; color: black"
              ></number-input>
            </td>

            <td>
              <br />
              <h3 style="font-weight: bold">{{ getTotalPrice(index) }}</h3>
            </td>
          </tr>
        </tbody>
      </table>
      <hr />
      <strong>TOTAL: ${{ totalPrice }}</strong>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Vue from "vue";
import VueNumberInput from "@chenfengyuan/vue-number-input";
import * as types from "@/store/types";
import { formatNumber } from "@/JS/FormatNumber";

Vue.use(VueNumberInput);

export default {
  name: "CartTable",
  computed: {
    ...mapGetters({
      VUEX_ZIPCODE: types.ZIPCODE,
      CART: types.CART_LIST,
      currentSurveyObject: types.CURRENTSURVEYOBJECT,
    }),
  },
  mounted() {
    this.containerList = this.CART;
    this.getDeliveryInfoText();
    this.initializeTotalQuantity();
    this.getSubtotal();
    this.intializePopupLists(); //Intitalize showDeliveryPopup, showPickupPopup and showCSCPopup
  },
  data() {
    return {
      showDeliveryPopup: [],
      showCSCPopup: [],
      showPickupPopup: [],
      containerList: [],
      totalPrice: 0,
      totalQuantity: 0,
      deliveryInfoText: "",
      CSCInfoText:
        "CSC Survey only applicable for containers being used for export.",
    };
  },
  methods: {
    ...mapActions({
      updateCurrentSurvey: types.ACTIONS_UPDATE_CURRENTSURVEYOBJECT,
      updateDelivery: types.ACTIONS_UPDATE_DELIVERY,
    }),
    getDeliveryInfoText() {
      this.deliveryInfoText =
        "Estimated price based on postal code: " +
        this.VUEX_ZIPCODE +
        ". The delivery price will be recalculated at checkout when the full shipping address is provided.";
    },
    intializePopupLists() {
      //Initialize the popup lists to false intially.Clicking info icons will change specifc index element to true
      const size = this.containerList.length;
      this.showDeliveryPopup = new Array(size).fill(false);
      this.showPickupPopup = new Array(size).fill(false);
      this.showCSCPopup = new Array(size).fill(false);
    },
    updateAttributes(product) {
      const currentSurveyObject = {
        oldSku: product.sku,
        formattedSku: product.formattedSku,
        description: product.title,
        delivery: product.customAttributes.Delivery,
        type: product.customAttributes.Type,
        cscterms: product.customAttributes.CSCSurveyRequired,
        purpose: product.customAttributes.Purpose,
        imageurl: product.image,
        market_city: product.market_city,
      };

      this.updateCurrentSurvey(currentSurveyObject);
      this.maintainLocalStorageSurveyObject();
      this.$router.push("/purchase/container");
    },
    initializeTotalQuantity() {
      for (var i = 0; i < this.containerList.length; i++)
        this.totalQuantity += this.containerList[i]["quantity"];
    },
    getProductsSize() {
      return this.containerList.length;
    },
    setQuantity(oldQuantity, newQuantity, index) {
      //update quanity, subtotal, total, LocalStorage Cart
      if (oldQuantity === newQuantity) return;
      else if (newQuantity < oldQuantity)
        this.totalQuantity -= oldQuantity - newQuantity;
      else this.totalQuantity += newQuantity - oldQuantity;
      this.containerList[index]["quantity"] = newQuantity;
      this.getSubtotal();
      this.maintainLocalStorageCart();
    },
    removecontainer(index) {
      //Remove line item, update total Price, update Info Popup Lists to cart size and localstorage cart
      this.totalQuantity -= this.containerList[index]["quantity"];
      this.containerList.splice(index, 1);
      this.getSubtotal();
      this.intializePopupLists();
      this.maintainLocalStorageCart();
    },
    computePrice(index) {
      var sum = this.containerList[index]["price"];
      if (this.totalQuantity >= 2) sum = sum - sum * 0.05; //add discount if total quantity is atleast 2
      if ("CSCSurvey" in this.containerList[index])
        sum += parseInt(this.containerList[index]["CSCSurvey"]["price"]);
      if (
        this.containerList[index]["customAttributes"]["Delivery"] === "DELIVERY"
      )
        sum += parseInt(this.containerList[index]["haulingPrice"]);
      return this.containerList[index]["quantity"] * sum;
    },
    getTotalPrice(index) {
      let totalPrice = this.computePrice(index);
      return "$" + formatNumber(totalPrice);
    },
    getSubtotal() {
      var total = 0;
      for (var index in this.containerList) total += this.computePrice(index);

      this.totalPrice = formatNumber(total);
    },
    updateItemsDelivery(deliveryType) {
      //change the delivery type of entire cart
      //Changing value for each index is not reactive in vue, hence use Vue.set() method to overwrite each line item.      
      this.updateDelivery(deliveryType);
      for (var index in this.containerList) {
        var cartItem = this.containerList[index];
        cartItem["customAttributes"]["Delivery"] = deliveryType.toUpperCase();
        this.$set(this.containerList, index, cartItem);
      }
      this.maintainLocalStorageCart();
      var toast_message =
        "Delivery is changed to: " +
        deliveryType.charAt(0).toUpperCase() +
        deliveryType.substr(1).toLowerCase();
      this.$toast(toast_message, {
        id: "auto",
        type: "success",
        position: "top-center",
        timeout: 2000,
      });
    },
    maintainLocalStorageCart() {
      const containerdetailes = JSON.stringify(this.containerList);
      localStorage.setItem("containerdetailes", containerdetailes);
    },
    maintainLocalStorageSurveyObject() {
      const currentSurveyObject = JSON.stringify(this.currentSurveyObject);
      localStorage.setItem("currentSurveyObject", currentSurveyObject);
    },
    format(num) {
      return formatNumber(num);
    },
  },
};
</script>

<style scoped>
.btns {
  text-decoration: none;
  font-weight: 700;
  text-transform: unset !important;
  border-radius: 15px;
  margin: 5px;
}

.shopping-cart {
  text-align: center;
  margin: auto;
  width: 90%;
}

.col {
  width: 14%;
}

.description {
  font-weight: bold;
}

.unit-price-discount {
  text-align: center;
  color: #6dbe45;
}

.unit-price-linethrough {
  text-decoration: line-through;
  font-weight: lighter;
}

.emptyCart p {
  font-size: 25px;
  color: white;
}

.dialog {
  background-color: white;
  border-radius: 15px;
  padding: 15px;
}

a {
  font-size: 20px;
}

strong {
  font-size: 20px;
}

table > thead > tr > th {
  border: 0;
}

hr {
  border: 2px solid rgb(128, 128, 128, 0.5);
}

@media only screen and (max-width: 880px) {
  .image {
    max-width: 50px;
  }

  table {
    width: 80%;
  }

  /* Force table to not be like tables anymore */
  table,
  thead,
  tbody,
  th,
  td,
  tr {
    display: block;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .row {
    text-align: center;
  }

  td {
    border: none;
    text-align: center;
    /* Behave  like a "row" */
    position: relative;
    padding-left: 50%;
  }

  td:before {
    /* Now like a table header */
    position: absolute;
    float: left;
    /* Top/left values mimic padding */
    top: 6px;
    left: 6px;
    width: 45%;
    padding-right: 10px;
    white-space: nowrap;
  }

  /*
Label the data
*/
  td:nth-of-type(1):before {
    content: "Price";
  }
  td:nth-of-type(2):before {
    content: "Delivery";
  }
  td:nth-of-type(3):before {
    content: "CSC Survey";
  }
  td:nth-of-type(4):before {
    content: "Quantity";
  }
  td:nth-of-type(5):before {
    content: "Total";
  }
  th:nth-of-type(0) {
    border-width: 2px;
    border-color: rgb(128, 128, 128, 0.5);
  }
  td:nth-of-type(0) {
    border: none;
  }
}

@media only screen and (max-width: 880px) {
  h3,
  div,
  p,
  a,
  v-btn,
  input,
  strong,
  h2 {
    font-size: 20px;
  }
}

@media only screen and (min-width: 880px) and (max-width: 1100px) {
  h3,
  div,
  p,
  a,
  v-btn,
  input,
  strong,
  h2 {
    font-size: 11px;
  }
}

@media only screen and (min-width: 1100px) and (max-width: 1400px) {
  h3,
  v-btn,
  div,
  p,
  a,
  input,
  strong,
  h2 {
    font-size: 18px;
  }
}

@media only screen and (min-width: 1400px) {
  h3,
  v-btn,
  div,
  p,
  a,
  input,
  strong,
  h2 {
    font-size: 24px;
  }
}
</style>
